import React, { useCallback, useMemo } from 'react';
import { useController } from 'react-hook-form';
import ValueInput from '../value-input';
import FieldStatus from '../field-status';
import noop from '../../../utils/noop';
import transfromRequiredRule from '../../helpers/transform-required-rule';

const defaultRules = {};

const ValueInputField = ({
  name,
  control,
  rules: passedRules = defaultRules,
  onChange = noop,
  onBlur = noop,
  ...otherProps
}) => {
  const rules = useMemo(() => transfromRequiredRule(passedRules), [passedRules]);

  const { field, fieldState } = useController({
    name,
    control,
    rules,
  });

  const handleChange = useCallback(
    (value) => {
      field.onChange(value);

      if (onChange) {
        onChange(value);
      }
    },
    [field, onChange]
  );

  const handleBlur = useCallback(
    (...args) => {
      field.onBlur();
      if (onBlur) onBlur(...args);
    },
    [field, onBlur]
  );

  return (
    <React.Fragment>
      <ValueInput
        {...otherProps}
        value={field.value}
        name={field.name}
        onChange={handleChange}
        onBlur={handleBlur}
      />
      {fieldState.error && <FieldStatus appearance="error" text={fieldState.error.message} />}
    </React.Fragment>
  );
};

export default ValueInputField;
